import React, { Component } from 'react';
import Project from './Project';

export default class Projects extends Component {

    render() {
        const projects = this.props.projects.map((project) => {
            return (
                <div className="col-12 col-sm-3 m-5">
                    <Project details={project} />
                </div>
            )
        })
        return (
            <div className="container">
                <h1>Projects</h1>
                <div className="row d-flex flex-row justify-content-center">
                    {projects}
                </div>
            </div>
        )
    }
}
